<!-- 
	This is the dashboard layout, used in dashboard, tables, billing and profile pages.
 -->

<template>
  <div :class="darkType">
    <!-- Dashboard Layout -->
    <a-layout class="layout-dashboard" id="layout-dashboard" :class="[
      navbarFixed ? 'navbar-fixed' : '',
      showSidebar ? 'has-sidebar' : '',
      isSidebarMini ? 'has-sidebar-mini' : '',
      route.meta.layoutClass
    ]">
      <!-- Main Sidebar -->
      <DashboardSidebar
        :sidebarCollapsed="sidebarCollapsed"
        :sidebarColor="sidebarColor"
        :sidebarTextColor="sidebarTextColor"
        :sidebarSelectedTextColor="sidebarSelectedTextColor"
        :sidebarTheme="sidebarTheme"
        @toggleSidebar="toggleSidebar"
      />
      <!-- / Main Sidebar -->

      <!-- Layout Content -->
      <a-layout>
        <!-- Layout Header's Conditionally Fixed Wrapper -->
        <DashboardHeader
          :sidebarCollapsed="sidebarCollapsed"
          :navbarFixed="navbarFixed"
          :sidebarColor="sidebarColor"
          :sidebarTextColor="sidebarTextColor"
          :sidebarSelectedTextColor="sidebarSelectedTextColor"
          @toggleSettingsDrawer="toggleSettingsDrawer"
          @toggleSidebar="toggleSidebar"
        ></DashboardHeader>
        <!-- / Layout Header's Conditionally Fixed Wrapper -->

        <!-- Page Content -->
        <a-layout-content>
          <router-view />
        </a-layout-content>
        <!-- / Page Content -->

        <!-- Layout Footer -->
        <DashboardFooter></DashboardFooter>
        <!-- / Layout Footer -->

        <!-- Floating Action Button For Toggling Settings Drawer -->
        <!-- <h-button class="fab" shape="circle" @click="showSettingsDrawer = true">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z"
              fill="#111827" />
          </svg>
        </h-button> -->
        <!-- / Floating Action Button For Toggling Settings Drawer -->

        <!-- Sidebar Overlay -->
        <div class="sidebar-overlay" @click="sidebarCollapsed = true" v-show="isMobile && !sidebarCollapsed"></div>
        <!-- / Sidebar Overlay -->
      </a-layout>
      <!-- / Layout Content -->

      <!-- Settings Drawer -->
      <DashboardSettingsDrawer
        :showSettingsDrawer="showSettingsDrawer"
        :navbarFixed="navbarFixed"
        :sidenavType="sidenavType"
        :darkMode="isDarkMode"
        :sidebarColor="sidebarColor"
        :sidebarTextColor="sidebarTextColor"
        :sidebarSelectedTextColor="sidebarSelectedTextColor"
        @toggleSettingsDrawer="toggleSettingsDrawer"
        @toggleNavbarPosition="toggleNavbarPosition"
        @updateSidenavType="updateSidenavType"
        @updateSidebarColor="updateSidebarColor"
        @updateSidebarTextColor="updateSidebarTextColor"
        @updateSidebarSelectedTextColor="updateSidebarSelectedTextColor"
        @darkModel="darkModel"
      />
      <!-- / Settings Drawer -->
    </a-layout>
    <!-- / Dashboard Layout -->
  </div>
</template>
<script lang="ts" setup>
import { watch, ref, onMounted, onBeforeUnmount, computed } from "vue";
import DashboardSidebar from "@/components/Sidebars/DashboardSidebar.vue";
import DashboardHeader from "@/components/Headers/DashboardHeader.vue";
import DashboardFooter from "@/components/Footers/DashboardFooter.vue";
import DashboardSettingsDrawer from "@/components/Sidebars/DashboardSettingsDrawer.vue";
import { useRouter, useRoute } from "vue-router";
import cookiesConFig from "@/utils/CookiesConfig";
import {
  DARK_TYPE,
  SIDEBAR_COLOR,
  SIDEBAR_THEME,
  SIDEBAR_TEXT_COLOR,
  SIDEBAR_SELECTED_TEXT_COLOR,
  SIDENAV_TYPE,
  NAVBAR_FIXED,
  SHOW_SETTINGS_DRAWER,
} from "@/const/ConstCookies";
import store from '@/store/index'
const route = useRoute();
const LG_BREAKPOINT = 992;
const isMobileViewport = () =>
  typeof window !== "undefined" && window.innerWidth < LG_BREAKPOINT;

const sidebarCollapsed = ref(isMobileViewport());
const wasMobile = ref(isMobileViewport());
const isMobile = ref(isMobileViewport());
const sidebarColor = ref("primary");
const sidebarTextColor = ref("primary");
const sidebarSelectedTextColor = ref("white");
const sidenavType = ref(true);
const sidebarTheme = ref("dark");
const navbarFixed = ref(false);
const showSettingsDrawer = ref(false);
const darkType = ref("");
// const layoutClass = computed(() => {
//   return route.meta.layoutClass;
// });
const layoutClass = ref('default');
const isLayoutClass = computed(() => {
  return store.getters.isLayoutClass
})

watch(isLayoutClass, async (newValue, oldValue) => {
  layoutClass.value = newValue
  if (newValue == null || newValue == '') {
    layoutClass.value = 'default'
  } else {
    layoutClass.value = newValue
  }
})

const syncSidebarForViewport = () => {
  const mobile = isMobileViewport();
  isMobile.value = mobile;
  // Only auto-hide when crossing from desktop -> tablet/mobile
  if (mobile && !wasMobile.value) {
    sidebarCollapsed.value = true;
  }
  // Restore sidenav type when returning to desktop
  if (!mobile && wasMobile.value) {
    sidebarCollapsed.value = !sidenavType.value;
  }
  wasMobile.value = mobile;
};

const showSidebar = computed(() => (isMobile.value ? !sidebarCollapsed.value : true));
const isSidebarMini = computed(() => !isMobile.value && sidebarCollapsed.value);
const isDarkMode = computed(() => darkType.value === "dark-mode");

const applyDocumentDarkMode = (enabled: boolean) => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle("dark-mode", enabled);
  document.body.classList.toggle("dark-mode", enabled);
};

const readSidenavType = () => {
  const raw = cookiesConFig.getCokies(SIDENAV_TYPE);
  if (raw === "" || raw === null || raw === undefined) return true;
  return raw === "true" || raw === true;
};

const applySidenavType = (full: boolean) => {
  sidenavType.value = full;
  cookiesConFig.setCokies(SIDENAV_TYPE, full);
  if (!isMobile.value) {
    sidebarCollapsed.value = !full;
  }
};

onMounted(() => {
  modelConfig();
  isMobile.value = isMobileViewport();
  if (isMobileViewport()) {
    sidebarCollapsed.value = true;
  } else {
    sidebarCollapsed.value = !sidenavType.value;
  }
  applyDocumentDarkMode(isDarkMode.value);
  window.addEventListener("resize", syncSidebarForViewport);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", syncSidebarForViewport);
  applyDocumentDarkMode(false);
});

const toggleSidebar = (val: any) => {
  sidebarCollapsed.value = val;
  if (!isMobile.value) {
    const full = !val;
    sidenavType.value = full;
    cookiesConFig.setCokies(SIDENAV_TYPE, full);
  }
};

const toggleSettingsDrawer = (val: any) => {
  cookiesConFig.setCokies(SHOW_SETTINGS_DRAWER, val);
  showSettingsDrawer.value = val;
};

const toggleNavbarPosition = (val: any) => {
  cookiesConFig.setCokies(NAVBAR_FIXED, val);
  navbarFixed.value = val;
};

const updateSidenavType = (val: any) => {
  applySidenavType(val === true || val === "true");
};

const updateSidebarColor = (val: any) => {
  const color = val || "primary";
  cookiesConFig.setCokies(SIDEBAR_COLOR, color);
  sidebarColor.value = color;
};

const updateSidebarTextColor = (val: any) => {
  const color = val || "primary";
  cookiesConFig.setCokies(SIDEBAR_TEXT_COLOR, color);
  sidebarTextColor.value = color;
};

const updateSidebarSelectedTextColor = (val: any) => {
  const color = val || "white";
  cookiesConFig.setCokies(SIDEBAR_SELECTED_TEXT_COLOR, color);
  sidebarSelectedTextColor.value = color;
};

const darkModel = (val: any) => {
  const mode = val === "dark-mode" ? "dark-mode" : "";
  cookiesConFig.setCokies(DARK_TYPE, mode);
  darkType.value = mode;
  applyDocumentDarkMode(mode === "dark-mode");
};

const modelConfig = () => {
  sidebarColor.value = cookiesConFig.getCokies(SIDEBAR_COLOR) || "primary";
  sidebarTextColor.value = cookiesConFig.getCokies(SIDEBAR_TEXT_COLOR) || "primary";
  sidebarSelectedTextColor.value =
    cookiesConFig.getCokies(SIDEBAR_SELECTED_TEXT_COLOR) || "white";
  sidenavType.value = readSidenavType();
  sidebarTheme.value = cookiesConFig.getCokies(SIDEBAR_THEME) || "dark";
  navbarFixed.value = cookiesConFig.getCokiesBoolean(NAVBAR_FIXED);
  showSettingsDrawer.value = cookiesConFig.getCokiesBoolean(SHOW_SETTINGS_DRAWER);
  const savedDark = cookiesConFig.getCokies(DARK_TYPE);
  darkType.value = savedDark === "dark-mode" ? "dark-mode" : "";
};
</script>
<!-- <script>

	import DashboardSidebar from '../components/Sidebars/DashboardSidebar' ;
	import DashboardHeader from '../components/Headers/DashboardHeader' ;
	import DashboardFooter from '../components/Footers/DashboardFooter' ;
	import DashboardSettingsDrawer from '../components/Sidebars/DashboardSettingsDrawer' ;

	export default ({
		components: {
			DashboardSidebar,
			DashboardHeader,
			DashboardFooter,
			DashboardSettingsDrawer,
		},
		data() {
			return {
				// Sidebar collapsed status.
				sidebarCollapsed: false,
				
				// Main sidebar color.
				sidebarColor: "primary",
				
				// Main sidebar theme : light, white, dark.
				sidebarTheme: "dark",

				// Header fixed status.
				navbarFixed: false,

				// Settings drawer visiblility status.
				showSettingsDrawer: false,
			}
		},
		methods: {
			toggleSidebar( value ) {
				this.sidebarCollapsed = value ;
			},
			toggleSettingsDrawer( value ) {
				this.showSettingsDrawer = value ;
			},
			toggleNavbarPosition( value ) {
				this.navbarFixed = value ;
			},
			updateSidebarTheme( value ) {
				this.sidebarTheme = value ;
			},
			updateSidebarColor( value ) {
				this.sidebarColor = value ;
			},
		},
		computed: {
			// Sets layout's element's class based on route's meta data.
			layoutClass() {
				return this.$route.meta.layoutClass ;
			}
		},
	})

</script> -->
